import { render } from "./JFdeduct.vue?vue&type=template&id=22a7df8c&scoped=true"
import script from "./JFdeduct.vue?vue&type=script&lang=js"
export * from "./JFdeduct.vue?vue&type=script&lang=js"

import "./JFdeduct.vue?vue&type=style&index=0&id=22a7df8c&lang=scss&scoped=true"
import "./JFdeduct.vue?vue&type=style&index=1&id=22a7df8c&lang=css"

import exportComponent from "D:\\workCode\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22a7df8c"]])

export default __exports__